module.exports = __webpack_public_path__ + "static/img/advert.f6b28595.png";